import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1e452e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group d-flex flex-wrap" }
const _hoisted_15 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group d-flex flex-wrap" }
const _hoisted_18 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_19 = { class: "el-form-item__content" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group d-flex flex-wrap" }
const _hoisted_22 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group d-flex flex-wrap" }
const _hoisted_25 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_26 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_27 = { class: "el-input-group__append d-flex w-auto flex-center" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group d-flex flex-wrap" }
const _hoisted_30 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_31 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_32 = { class: "el-input-group__append d-flex w-auto flex-center" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "form-group d-flex flex-wrap" }
const _hoisted_35 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "form-group d-flex flex-wrap" }
const _hoisted_38 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_39 = { class: "col-md-12" }
const _hoisted_40 = { class: "form-group d-flex flex-wrap" }
const _hoisted_41 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1))
const _hoisted_43 = { class: "col-md-12" }
const _hoisted_44 = { class: "form-group d-flex flex-wrap" }
const _hoisted_45 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "el-upload__tip" }
const _hoisted_50 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_52 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "indicator-label" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_56 = { class: "indicator-progress" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_auth = _resolveDirective("auth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_form, {
    onSubmit: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
    rules: _ctx.rules,
    model: _ctx.formData,
    ref: "formRef"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("common.information")), 1)
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("quickSettlement.type")), 1),
                _createVNode(_component_el_form_item, { prop: "order_type" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.order_type,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.order_type) = $event)),
                      clearable: "",
                      disabled: _ctx.options.defaultFormData.order_status == '2',
                      placeholder: _ctx.t('common.plsSelect'),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.type, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("quickSettlement.orderNumber")), 1),
                _createVNode(_component_el_form_item, { prop: "order_number" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.order_number,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.order_number) = $event)),
                      clearable: "",
                      placeholder: _ctx.t('common.plsEnter')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("common.customer")), 1),
                _createVNode(_component_el_form_item, { prop: "customer_id" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.customer_name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.customer_name) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("quickSettlement.orderStatus")), 1),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", _ctx.statusClass(_ctx.formData.order_status)])
                  }, _toDisplayString(_ctx.options.order_status.get(Number(_ctx.formData.order_status))), 3)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("quickSettlement.paymentStatus")), 1),
                _createVNode(_component_el_form_item, { prop: "status" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.status,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.status) = $event)),
                      filterable: "",
                      clearable: "",
                      remote: "",
                      placeholder: _ctx.t('common.plsSelect'),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.payment_status, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.t("quickSettlement.orderAmount")), 1),
                _createVNode(_component_el_form_item, { prop: "order_amount" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_el_input_number, {
                        class: "text-start w-100",
                        modelValue: _ctx.formData.order_amount,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.order_amount) = $event)),
                        precision: 2,
                        step: 0.01,
                        min: 0,
                        controls: false
                      }, null, 8, ["modelValue", "step"]),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.order_currency,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.order_currency) = $event)),
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.currency, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("quickSettlement.paidAmount")), 1),
                _createVNode(_component_el_form_item, { prop: "pay_amount" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_el_input_number, {
                        class: "text-start w-100",
                        modelValue: _ctx.formData.pay_amount,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.pay_amount) = $event)),
                        precision: 2,
                        step: 0.01,
                        min: 0,
                        controls: false
                      }, null, 8, ["modelValue", "step"]),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.pay_currency,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.pay_currency) = $event)),
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.currency, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.t("quickSettlement.distributionModel")), 1),
                _createVNode(_component_el_form_item, { prop: "distribution_model" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.distribution_model,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.distribution_model) = $event)),
                      clearable: "",
                      placeholder: _ctx.t('common.plsSelect'),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.distribution_model, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.t("quickSettlement.dueDate")), 1),
                _createVNode(_component_el_form_item, { prop: "due_date" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formData.due_date,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.due_date) = $event)),
                      type: "date",
                      clearable: "",
                      disabled: _ctx.options.defaultFormData.order_status == '2',
                      placeholder: _ctx.t('common.pickDate'),
                      format: "DD.MM.YYYY",
                      style: {"width":"100%"},
                      onChange: _cache[10] || (_cache[10] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'due_date')
                  ))
                    }, null, 8, ["modelValue", "disabled", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.t("quickSettlement.remark")), 1),
                _createVNode(_component_el_form_item, { prop: "comment" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.comment,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.comment) = $event)),
                      type: "textarea",
                      placeholder: _ctx.t('common.plsEnter'),
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("h3", null, _toDisplayString(_ctx.t("common.fileUpload")), 1),
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.t("quickSettlement.selectFile")), 1),
              _createVNode(_component_el_form_item, { prop: "file_id" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_upload, {
                    ref: "uploadRefs.file_id",
                    accept: ".xls,.xlsx",
                    "file-list": _ctx.uploadData.file_id,
                    action: _ctx.uploadUrl,
                    data: { id: _ctx.id },
                    headers: _ctx.uploadHeaders,
                    disabled: 
                  _ctx.uploadDisabled.file_id || _ctx.formData.order_status == '2'
                ,
                    limit: 1,
                    "auto-upload": true,
                    "on-progress": 
                  function (e, file, fileList) {
                    return _ctx.handleProgress(e, file, fileList, 'file_id');
                  }
                ,
                    "on-success": 
                  function (response, file, fileList) {
                    return _ctx.handleSuccess(
                      response,
                      file,
                      fileList,
                      'file_id',
                      _ctx.formData
                    );
                  }
                ,
                    "on-error": 
                  function (err, file, fileList) {
                    return _ctx.handleError(err, file, fileList, 'file_id');
                  }
                ,
                    "on-remove": 
                  function (file, fileList) {
                    return _ctx.handleRemove(
                      file,
                      fileList,
                      'file_id',
                      _ctx.formData,
                      _ctx.uploadData,
                      _ctx.removeFlag
                    );
                  }
                ,
                    "on-exceed": 
                  function (files, fileList) {
                    return _ctx.handleExceed(files, fileList, 'file_id');
                  }
                ,
                    "before-upload": _ctx.handleBeforeUpload
                  }, {
                    trigger: _withCtx(() => [
                      _withDirectives((_openBlock(), _createElementBlock("button", {
                        type: "button",
                        class: "btn btn-primary btn-sm me-2",
                        disabled: 
                      _ctx.uploadDisabled.file_id || _ctx.formData.order_status == '2'
                    
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t("common.fileUpload")), 1)
                      ], 8, _hoisted_46)), [
                        [_directive_auth, { auth: ['update'] }]
                      ])
                    ]),
                    tip: _withCtx(() => [
                      _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.t("quickSettlement.uploadTip")), 1)
                    ]),
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createElementBlock("button", {
                        type: "button",
                        class: "btn btn-danger btn-sm me-2",
                        disabled: 
                    _ctx.uploadDisabled.file_id ||
                    _ctx.formData.file_id === 0 ||
                    _ctx.formData.order_status == '2'
                  ,
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleDeleteUpload('file_id', _ctx.formData)))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t("common.fileDelete")), 1)
                      ], 8, _hoisted_47)), [
                        [_directive_auth, { auth: ['update'] }]
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("button", {
                        type: "button",
                        class: "btn btn-success btn-sm me-2",
                        disabled: _ctx.uploadDisabled.file_id || _ctx.formData.file_id === 0,
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handlePreview('file_id', _ctx.formData)))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t("common.fileDownload")), 1)
                      ], 8, _hoisted_48)), [
                        [_directive_auth, { auth: ['export'] }]
                      ])
                    ]),
                    _: 1
                  }, 8, ["file-list", "action", "data", "headers", "disabled", "on-progress", "on-success", "on-error", "on-remove", "on-exceed", "before-upload"])
                ]),
                _: 1
              })
            ])
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary align-self-center me-2",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
          }, [
            _hoisted_51,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("common.backToList")), 1)
          ]),
          _createVNode(_component_permission_common, { role: { auth: ['model'] } }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("button", {
                type: "button",
                class: "btn btn-danger me-2",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.cancelQuickSettlement && _ctx.cancelQuickSettlement(...args)))
              }, [
                _createElementVNode("span", _hoisted_52, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("quickSettlement.void")), 1)
              ], 512), [
                [_vShow, _ctx.formData.order_status == '1']
              ]),
              _createElementVNode("button", {
                type: "submit",
                ref: "submitButton",
                class: "btn btn-primary me-2",
                disabled: _ctx.loading || _ctx.uploadDisabled.file_id
              }, [
                _createElementVNode("span", _hoisted_54, [
                  _hoisted_55,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("common.saveChanges")), 1)
                ]),
                _createElementVNode("span", _hoisted_56, [
                  _createTextVNode(_toDisplayString(_ctx.$t("common.pleaseWait")) + " ", 1),
                  _hoisted_57
                ])
              ], 8, _hoisted_53)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["rules", "model"]))
}